<template>
  <div>
    <div class="row">
      <div v-if="tipoIndicador === 'cuantitativo' " class="col-12 divInfo">
        <span v-if="!isManual">*Si modifica la información relativa a dato de partida y/o periodicidad y/o unidad se eliminarán los datos intermedios introducidos.</span>
      </div>
      <div class="col-4 divInputTable">
        <InputTable
          v-if="rowPartida"
          type="partida"
          :isManual ="isManual"
          :col="colPartida"
          :row="rowPartida"
          :rowObjetivoPartida="rowPartida"
          @updateDatosPartidaYObjetivo="fillDatosPartida" />
                </div>
      <div class="col-4 divInputTable">
        <InputTable
          v-if="rowObjetivo"
          type="objetivo"
          :isManual ="isManual"
          :col="colObjetivo"
          :row="rowObjetivo"
          :rowObjetivoPartida="rowObjetivo"
          @updateDatosPartidaYObjetivo="fillDatosObjetivo" />
      </div>
      <div class="col-4">
        <div v-if="tipoIndicador === 'cuantitativo' " class="row">
          <q-select
            label="Periodicidad de la medida de datos"
            class="input col-12 required"
            outlined
            :options="
              optionsPeriodicidad ? optionsPeriodicidad : 'No hay datos'
            "
            option-value="id"
            option-label="name"
            v-model="$v.optionPeriodicidadSelected.$model"
            @input="edited()"
            :error="$v.optionPeriodicidadSelected.$error"
            :disable="isOnlyAccess"
          >
            <template v-slot:error>
              <span v-if="isManual">Dato obligatorio.</span>
            </template>
          </q-select>
        </div>
        <div v-if="tipoIndicador === 'satelital' " class="row">
          <div class="divPeriodicidad" v-if="tipoIndicador === 'satelital'">
            <div class="divLabel">Periodicidad de la medida de datos</div>
            <div>{{optionPeriodicidadSelected}}</div>
          </div>
        </div>
        <div class="row">
          <q-input
            v-if="tipoIndicador !== 'satelital'"
            outlined
            label="Unidad de medida"
            class="required col-12"
            v-model.trim="$v.unidadMedida.$model"
            :error="$v.unidadMedida.$error"
            @input="edited()"
            :readonly="isOnlyAccess"
          >
            <template v-slot:error>
              <span v-if="isManual">Dato obligatorio.</span>
            </template>
          </q-input>

          <div class="divUnidadMedida" v-if="tipoIndicador === 'satelital'">
            <div class="divLabel">Unidad de medida</div>
            <div>{{unidadMedida}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tipoIndicador === 'cuantitativo' " class="row">
      <div class="col-12">
        <q-input
          v-model="fuenteDatoPartida"
          label="Fuente del dato de partida"
          outlined
          @input="edited()"
          :readonly="isOnlyAccess"
        ></q-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <q-input
          v-model="observaciones"
          type="textarea"
          label="Observaciones"
          outlined
          @input="edited()"
          :readonly="isOnlyAccess"
        ></q-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <q-input
          v-model="indicadoresAsociados"
          type="textarea"
          label="Indicadores complementarios no pertenecientes a AUE"
          outlined
          @input="edited()"
          :readonly="isOnlyAccess"
        ></q-input>
      </div>
    </div>
  </div>
</template>
<script>
import InputTable from '@/components/PlanAccion/components/InputTable.vue';
import { required } from 'vuelidate/lib/validators';
import * as types from '@/storeModules/NGUD/types';
import moment from 'moment';
import Vue from 'vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    InputTable
  },
  validations: {
    unidadMedida: { required },
    optionPeriodicidadSelected: { required }
  },
  props: {
    datosPartidaYObjetivo: Object,
    tipoIndicador: String,
    isManual: Boolean
  },
  computed: {
    ...mapGetters({
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  created () {
    Vue.set(this.rowObjetivo, 'fecha', null);
    Vue.set(this.rowPartida, 'fecha', null);
    Vue.set(this.rowObjetivo, 'fechaMinima', null);
    this.fillData();

    if (this.tipoIndicador !== 'satelital') {
      this.$store
        .dispatch(types.ACTION_GET_PERIODICIDAD)
        .then(response => {
          this.optionsPeriodicidad = response.data.periodicidades;
        });
    }
  },
  watch: {
    datosPartidaYObjetivo () {
      this.fillData();
    }
  },
  data () {
    return {
      observaciones: '',
      fuenteDatoPartida: '',
      indicadoresAsociados: '',
      unidadMedida: '',
      optionsPeriodicidad: [],
      optionPeriodicidadSelected: [],
      colPartida: 'Dato de Partida',
      colObjetivo: 'Dato objetivo',
      rowPartida: { dato: '', fecha: null },
      rowObjetivo: { dato: '', fecha: null, fechaMinima: null }
    };
  },
  methods: {
    fillData () {
      if (this.datosPartidaYObjetivo) {
        this.observaciones = this.datosPartidaYObjetivo.observaciones;
        this.indicadoresAsociados = this.datosPartidaYObjetivo.indicadoresAsociados;
        this.optionPeriodicidadSelected = this.datosPartidaYObjetivo.periodicidad;
        this.unidadMedida = this.datosPartidaYObjetivo.unidadMedida;
        this.datoObjetivo = this.datosPartidaYObjetivo.datoObjetivo;
        this.fechaDatoObjetivo = this.datosPartidaYObjetivo.fechaDatoObjetivo;
        this.datoPartida = this.datosPartidaYObjetivo.datoPartida;
        this.fechaDatoPartida = this.datosPartidaYObjetivo.fechaDatoPartida;
        this.fuenteDatoPartida = this.datosPartidaYObjetivo.fuenteDatoPartida;
        Vue.set(this.rowObjetivo, 'fecha', null);
        Vue.set(this.rowPartida, 'fecha', null);
        Vue.set(this.rowObjetivo, 'dato', this.datosPartidaYObjetivo.datoObjetivo);
        Vue.set(this.rowPartida, 'dato', this.datosPartidaYObjetivo.datoPartida);
        if (this.datosPartidaYObjetivo.hasOwnProperty('fechaDatoObjetivo') && this.datosPartidaYObjetivo.fechaDatoObjetivo !== undefined) {
          Vue.set(this.rowObjetivo, 'fecha', moment(new Date(this.datosPartidaYObjetivo.fechaDatoObjetivo)).format('YYYY/MM/DD'));
        }
        if (this.datosPartidaYObjetivo.hasOwnProperty('fechaDatoPartida') && this.datosPartidaYObjetivo.fechaDatoPartida !== undefined) {
          Vue.set(this.rowPartida, 'fecha', moment(new Date(this.datosPartidaYObjetivo.fechaDatoPartida)).format('YYYY/MM/DD'));
          Vue.set(this.rowObjetivo, 'fechaMinima', moment(new Date(this.datosPartidaYObjetivo.fechaDatoPartida)).format('YYYY/MM/DD'));
        }
      }
    },
    fillDatosPartida (datosPartida) {
      this.datoPartida = datosPartida.dato;
      this.fechaDatoPartida = datosPartida.fecha;
      this.rowObjetivo.fechaMinima = datosPartida.fecha;
      this.edited();
    },
    fillDatosObjetivo (datosObjetivo) {
      this.datoObjetivo = datosObjetivo.dato;
      this.fechaDatoObjetivo = datosObjetivo.fecha;
      this.edited();
    },
    edited () {
      let dataIndicador = {
        observaciones: this.observaciones,
        indicadoresAsociados: this.indicadoresAsociados,
        periodicidad: this.optionPeriodicidadSelected,
        unidadMedida: this.unidadMedida,
        datoObjetivo: this.datoObjetivo,
        fechaDatoObjetivo: this.fechaDatoObjetivo,
        datoPartida: this.datoPartida,
        fechaDatoPartida: this.fechaDatoPartida,
        fuenteDatoPartida: this.fuenteDatoPartida
      };
      this.$emit('updateDataDatosPartidaYObjetivo', dataIndicador);
    }
  }
};
</script>
<style lang="scss" scoped>
.row {
  margin-top: 15px;
  .q-select{
    padding-bottom: 0px;
  }
}
.divInputTable {
  padding-right: 15px;
}
.divLabel{
  font-family: DINPro;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.27px;
  color: #002f6c;
  margin-bottom:5px;
}
.divPeriodicidad, .divUnidadMedida{
  margin-left: 15px;
}
.divPeriodicidad{
  margin-top: 25px;
}
.divUnidadMedida{
  margin-top: 15px;
}
.divInfo{
  margin: 15px 0px 1px 0px;
  font-family: DINPro;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.09px;
  color: #555;
}
</style>
